/* @flow */

export function nonEmpty(value: any): ?string {
    if (value && value.length === 0) {
        return 'Please select at least one item';
    }
}
